import { render, staticRenderFns } from "./TechAreasPageCreate.vue?vue&type=template&id=552e9018&"
import script from "./TechAreasPageCreate.vue?vue&type=script&lang=ts&"
export * from "./TechAreasPageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552e9018')) {
      api.createRecord('552e9018', component.options)
    } else {
      api.reload('552e9018', component.options)
    }
    module.hot.accept("./TechAreasPageCreate.vue?vue&type=template&id=552e9018&", function () {
      api.rerender('552e9018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/TechAreasPageCreate.vue"
export default component.exports